<div class="content" style="background-color: darkgrey; height: 100%;">
    <div class="content-center" style="color: whitesmoke;">
        <br>
        <h1  style="color: white;">Account Disabled</h1>
        <h2  style="color: whitesmoke;">You cannot use it while it is disabled</h2>
        <br>

        <div class="content" style=" background-color: blue;justify-content: center; height: 4em;padding: 0px;border-radius: 0.5em;"
            routerLink="">
            <span>Return to Login</span>
        </div>

    </div>
</div>